import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { Util } from '../../util/util';
import { MedicoService } from '../medico.service';

@Component({
  selector: 'app-medico-list',
  templateUrl: './medico-list.component.html',
  styleUrls: ['./medico-list.component.css']
})
export class MedicoListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'cpf', 'fone', 'details'];

  constructor(private medicoService: MedicoService, router: Router, dialog: MatDialog) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.data = data;
        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.medicoService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterMedico']);
  }

  details(id: number) {
    this.router.navigate(['manterMedico'], {
      state: {
        id: id,
        isUpdate: 'N'
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterMedico'], {
      state: {
        id: id,
        isUpdate: 'S'
      }
    });
  }

  pattern = Util.pattern;
}
